import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { getOrdersSettings as universalGetOrdersSettings, updateOrdersSettings as universalUpdateOrdersSettings, } from './ecom-v1-orders-settings-orders-settings.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function getOrdersSettings(httpClient) {
    return () => universalGetOrdersSettings(
    // @ts-ignore
    { httpClient });
}
export function updateOrdersSettings(httpClient) {
    return (ordersSettings) => universalUpdateOrdersSettings(ordersSettings, 
    // @ts-ignore
    { httpClient });
}
export const onOrdersSettingsUpdated = EventDefinition('wix.ecom.v1.orders_settings_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export { InventoryUpdateTrigger, WebhookIdentityType, } from './ecom-v1-orders-settings-orders-settings.universal.js';
//# sourceMappingURL=ecom-v1-orders-settings-orders-settings.public.js.map